import type { IconProps } from "./icon-types";

/**
 * 위치/대상으로 이동 — 지도 앱 "현재 위치" 관례의 navigation pointer.
 *
 * SigmaKit annotation playback bar가 같은 역할(캡처 프레임으로 이동)에 쓰는
 * FaLocationArrow의 c6 대응. 외부 아이콘 라이브러리를 런타임 의존하지 않는 정책에 따라
 * 같은 메타포를 c6 stroke 컨벤션(24 grid, stroke 2)으로 다시 그렸다.
 */
export const LocationArrowIcon = (props: IconProps) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    {...props}
  >
    <path d="M3 11 22 2l-9 19-2-8-8-2Z" />
  </svg>
);
